function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10.7185V21H4.66401V9.88208V6.99687H0V10.7185ZM19.8958 11.3012C19.587 8.64622 18.4366 6.99687 15.0215 6.99687C13.0207 6.99687 11.6689 7.77221 11.105 8.89059H11.0423V6.99687H7.32273V9.68941V21H11.2124V14.0548C11.2124 12.2269 11.557 10.4601 13.6921 10.4601C15.8406 10.4601 15.9972 12.5464 15.9972 14.1817V20.9953H19.9988V13.303C20.0077 12.5887 19.9674 11.9168 19.8958 11.3012ZM2.33201 0C1.04292 0 0 1.09487 0 2.44819C0 3.80152 1.04292 4.8964 2.33201 4.8964C3.62109 4.8964 4.66401 3.80152 4.66401 2.44819C4.66401 1.09487 3.62109 0 2.33201 0Z",
  fill: "#343434"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.d387ec11.svg";
export { ForwardRef as ReactComponent };